import { type ActivationErrorTypes, type BTLoginTypes } from "types/enum";

import { isNullOrUndefined } from "utilities/object/object";

import { type PreviousActivation } from "commonComponents/entity/credentials/Credentials/Credentials.api.types";

export enum UserActivationMethods {
    LinkAccount = 0,
    CreateAccount = 1,
}

export function isValidUserActivationMethod(
    activationMethod: UserActivationMethods | undefined,
): boolean {
    if (isNullOrUndefined(activationMethod) || isNaN(activationMethod)) {
        return false;
    }
    return Object.values(UserActivationMethods).includes(activationMethod);
}

export type UserActivationPageFormActions = undefined | "submit" | "addlink" | "login";

export interface IUserActivationPageFormValues {
    username: string;
    password: string;
    activationMethod?: UserActivationMethods;
}

interface IUserActivationLinkSignedInRequest {
    username: string;
    shareToken: string;
    isSignedIn: true;
}
interface IUserActivationNotSignedInLinkRequest {
    username: string;
    password: string;
    signInDescription: string;
    shareToken: string;
    isSignedIn: false;
}

export type IUserActivationLinkRequest =
    | IUserActivationNotSignedInLinkRequest
    | IUserActivationLinkSignedInRequest;

export interface IUserActivationPageLoginRequest {
    username: string;
    password: string;
    signInDescription: string;
}

export enum ExternalEntitiesWithUserActivation {
    BidSubmitted = 1,
    BidDeclined = 2,
    PurchaseOrderApproved = 3,
    PurchaseOrderDeclined = 4,
}
export interface ILinkAccountFormValues {
    username: string;
    password: string;
    recaptchaToken: string | null;
}

export interface ILinkAccountRequest {
    username: string;
    password?: string;
    shareToken: string;
    isSignedIn?: boolean;
}

export interface IAuth0ActivationResponse {
    globalUserId: number;
    loginType: BTLoginTypes;
    previousActivation: PreviousActivation;
    userId: number;
    errorType: ActivationErrorTypes;
    logoSrc: string;
    sessionLoginType: BTLoginTypes;
    builderName: string;
}

export class Auth0ActivationResponse implements IAuth0ActivationResponse {
    constructor(data: IAuth0ActivationResponse) {
        this.globalUserId = data.globalUserId;
        this.loginType = data.loginType;
        this.previousActivation = data.previousActivation;
        this.userId = data.userId;
        this.errorType = data.errorType;
        this.logoSrc = data.logoSrc;
        this.sessionLoginType = data.sessionLoginType;
        this.builderName = data.builderName;
    }
    globalUserId: number;
    loginType: BTLoginTypes;
    previousActivation: PreviousActivation;
    userId: number;
    errorType: ActivationErrorTypes;
    logoSrc: string;
    sessionLoginType: BTLoginTypes;
    builderName: string;
}

export interface IFinalizeActivationRequest {
    shareToken: string;
    emailAddress: string;
}
